export interface BasePartnerProfile {
  status: string;
  createdAt: string;
  createdBy: string;
  updatedBy: string;
  updatedAt: string;
  pocCompleted: boolean;
  companyCompleted: boolean;
}

export interface SupplyPartnerProfile extends BasePartnerProfile {
  spId: string;
  spName: string;
  spSellerID: string;
  paymentCompleted: boolean;
}

export interface DemandPartnerProfile extends BasePartnerProfile {
  dpId: string;
  dpName: string;
  dpType: string;
  rtbVersion: string;
  configCompleted: boolean;
}

export const dummySupplyPartners: SupplyPartnerProfile[] = [
  {
    spId: 'SP66838',
    spName: 'Crackle Media Exchange',
    spSellerID: 'SELLER-CRK-01',
    status: 'Active',
    createdAt: '2026-01-10T08:45:00Z',
    createdBy: 'c-admin@crackle.com',
    updatedBy: 'sp-ops@crackle.com',
    updatedAt: '2026-03-18T13:20:00Z',
    pocCompleted: true,
    paymentCompleted: true,
    companyCompleted: true
  },
  {
    spId: 'SP1002',
    spName: 'Northwind Inventory',
    spSellerID: 'SELLER-NW-14',
    status: 'Pending',
    createdAt: '2026-02-01T10:15:00Z',
    createdBy: 'sp-admin@northwind.com',
    updatedBy: 'sp-tech@northwind.com',
    updatedAt: '2026-03-14T09:05:00Z',
    pocCompleted: true,
    paymentCompleted: false,
    companyCompleted: true
  },
  {
    spId: 'SP1003',
    spName: 'Blue Ocean Supply',
    spSellerID: 'SELLER-BO-22',
    status: 'Active',
    createdAt: '2025-12-22T05:30:00Z',
    createdBy: 'ops@blueocean.com',
    updatedBy: 'ops@blueocean.com',
    updatedAt: '2026-03-17T17:45:00Z',
    pocCompleted: true,
    paymentCompleted: true,
    companyCompleted: false
  }
];

export const dummyDemandPartners: DemandPartnerProfile[] = [
  {
    dpId: 'DP14177',
    dpName: 'Bidscube',
    dpType: 'DSP',
    rtbVersion: '2.5',
    status: 'Active',
    createdAt: '2026-01-04T07:10:00Z',
    createdBy: 'c-user@crackle.com',
    updatedBy: 'dp-admin@bidscube.com',
    updatedAt: '2026-03-19T04:40:00Z',
    pocCompleted: true,
    configCompleted: true,
    companyCompleted: true
  },
  {
    dpId: 'DP16420',
    dpName: 'Open Reach DSP',
    dpType: 'DSP',
    rtbVersion: '2.6',
    status: 'Active',
    createdAt: '2026-02-08T11:30:00Z',
    createdBy: 'ops@crackle.com',
    updatedBy: 'dp-user@openreach.com',
    updatedAt: '2026-03-16T12:15:00Z',
    pocCompleted: true,
    configCompleted: false,
    companyCompleted: true
  },
  {
    dpId: 'DP17201',
    dpName: 'Summit Demand',
    dpType: 'Agency',
    rtbVersion: '2.5',
    status: 'Inactive',
    createdAt: '2025-11-18T14:25:00Z',
    createdBy: 'admin@summit.com',
    updatedBy: 'admin@summit.com',
    updatedAt: '2026-03-10T15:55:00Z',
    pocCompleted: false,
    configCompleted: false,
    companyCompleted: true
  }
];
